import React, { createContext, useContext } from 'react';
import { useFetch } from 'hooks/useFetch';
import { sidebar } from 'hooks/endpoints';

const SidebarDataContext = createContext();

export const SidebarDataProvider = ({ children }) => {
  const token = localStorage.getItem('token');

  const {
    data: sidebarData,
    refetch,
    isFetching,
  } = useFetch(['sidebarData'], sidebar.get, {
    enabled: !!token,
  });

  return (
    <SidebarDataContext.Provider
      value={{
        sidebarData,
        refetchSidebarData: refetch,
        isFetching,
      }}
    >
      {children}
    </SidebarDataContext.Provider>
  );
};

export const useSidebarData = () => useContext(SidebarDataContext);
